import { GlobalAlert } from '@thoughtspot/global-alert';
import React, { useState, useEffect, memo } from 'react';
import { ChartToTSEvent, TSToChartEvent, } from '@thoughtspot/ts-chart-sdk';
import { translate as t } from '@thoughtspot/i18n';
const CustomGlobalAlertToastComponent = ({ onEvent, emitEvent, }) => {
    const [globalToastAlertConfig, setglobalToastAlertConfig] = useState(null);
    const [isGlobalToastAlertVisible, setIsGlobalToastAlertVisible] = useState(false);
    useEffect(() => {
        if (onEvent) {
            onEvent(ChartToTSEvent.ShowGlobalAlertToast, {
                setIsGlobalToastAlertVisible,
                setglobalToastAlertConfig,
            });
        }
        return () => {
            setIsGlobalToastAlertVisible(false);
            setglobalToastAlertConfig(null);
        };
    }, [onEvent, emitEvent]);
    if (!isGlobalToastAlertVisible || !globalToastAlertConfig) {
        return null;
    }
    const message = globalToastAlertConfig.labelTranslation
        ? t(globalToastAlertConfig.labelTranslation)
        : globalToastAlertConfig.alertMessage;
    return (React.createElement(GlobalAlert.Toast, { message: message, isVisible: isGlobalToastAlertVisible, showCloseButton: globalToastAlertConfig.showCloseButton, showCheckmarkIcon: globalToastAlertConfig.showCheckmarkIcon, autoHide: globalToastAlertConfig.autoHide, primaryAction: globalToastAlertConfig.primaryActionButton
            ? {
                label: globalToastAlertConfig.primaryActionButton.label,
                onClick: () => {
                    emitEvent(TSToChartEvent.GlobalToastActionClick, {
                        ...globalToastAlertConfig.primaryActionButton,
                    });
                },
                isDisabled: globalToastAlertConfig.primaryActionButton
                    .isDisabled,
                tooltip: globalToastAlertConfig.primaryActionButton
                    .tooltip,
                type: globalToastAlertConfig.primaryActionButton.type,
            }
            : undefined, onClose: () => {
            setIsGlobalToastAlertVisible(false);
            setglobalToastAlertConfig(null);
        } }));
};
export default memo(CustomGlobalAlertToastComponent);
//# sourceMappingURL=toast.js.map